import { createSelector } from 'reselect'
import searchLessons from './private_library_search_lessons_selector'
import { localize } from 'helpers/translator'

const searchLessonsViewSelector = createSelector(
	[state => state.libraries, state => state.lessons, searchLessons],
	(libraries, lessonsList, searchLessonsData) => {
		const entityIds = libraries.find_lessons.selected_lessons
		let hasPaidLessons = false
		let alertTitle = ''
		const lessons = entityIds.filter(function(id) {
			return lessonsList[id].library_object_type === '1'
		}).map(function(id) {
			if (!lessonsList[id].data.free && !lessonsList[id].data.isAyce) {
				hasPaidLessons = true
			}
			return lessonsList[id].data.id
		})
		const bundles = entityIds.filter(function(id) {
			return lessonsList[id].library_object_type === '3'
		}).map(function(id) {
			if (!lessonsList[id].data.free && !lessonsList[id].data.isAyce) {
				hasPaidLessons = true
			}
			return lessonsList[id].data.entityUID
		})
		if (libraries.find_lessons.selected_all && libraries.find_lessons.total_has_paid_lessons) {
			hasPaidLessons = true
		}
		alertTitle = (bundles.length + lessons.length) > 1 ? localize('addLessons_multipleSchools_modal_title') : localize('addLesson_multipleSchools_modal_title')
		return {
			selected_all: libraries.find_lessons.selected_all,
			lessons,
			bundles,
			searchData: searchLessonsData.search,
			libraryUID: searchLessonsData.libraryUID,
			folderUID: libraries.current.folderUID,
			hasPaidLessons,
			multipleSchools: libraries.current.settings.multipleSchools,
			alertTitle,
		}
	}
)

export default searchLessonsViewSelector
